import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IBranding } from 'src/app/shared/interfaces/branding/branding';

@Injectable({ providedIn: 'root' })
export class BrandingService {

  private state = new BehaviorSubject<IBranding | null>(null);
  branding$ = this.state.asObservable();

  constructor(private http: HttpClient) {}

  load(): Observable<IBranding> {
    return this.http.get<IBranding>(`${environment.apiUrl}branding`).pipe(
      tap(b => {
        this.state.next(b);
        this.applyVars(b);
      })
    );
  }

  get snapshot(): IBranding | null {
    return this.state.getValue();
  }

  private applyVars(b: IBranding): void {
    const root = document.documentElement;
    root.style.setProperty('--color-primary',   b.color_primary);
    root.style.setProperty('--color-secondary',  b.color_secondary);
    root.style.setProperty('--color-tertiary',   b.color_tertiary);
  }
}
